<form class="p-fluid" [formGroup]="form" (ngSubmit)="submitForm()" uidsDragDropFile>

  <icbc-switchable-content [formGroup]="form" label="Content title/code or upload" [fileAwareFields]="fieldNames">
    <ng-template #textTemplate>
      <input class="p-inputtext form-input" id="subject" type="text" pInputText
             formControlName="subject" (keydown)="handleKeyup($event)" />
    </ng-template>
    <ng-template #fileTemplate>
      <icbc-upload-files-list [class.disabled-element]="usingContent" />
    </ng-template>
  </icbc-switchable-content>

  <div class="form-actions">
    <button class="iese-button" (click)="close()">
      <span>Cancel</span>
    </button>
    <button class="iese-button primary" (click)="clear()">
      <i class="pi pi-delete-left"></i>
      <span>Clear</span>
    </button>
    <button class="iese-button primary" type="submit" [class.disabled]="!form.valid">
      <i class="pi pi-send"></i>
      <span>Send</span>
    </button>
  </div>

</form>
